import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { HowItWorks } from '../components/HowItWorks';
import { DispatchBrain } from '../components/DispatchBrain';
import { PromiseSection } from '../components/PromiseSection';
import { StackSection } from '../components/StackSection';
import { Faq } from '../components/Faq';
import { CtaBand } from '../components/CtaBand';
import { usePageTitle } from '../hooks/usePageTitle';
export function HowItWorksPage() {
  usePageTitle('How It Works | Viridia Analytics');
  return <>
      <PageHeader eyebrow="How it works" title="A response system that sits in front of your team, not on top of it." body="We connect to the lines and lead sources you already pay for, answer every inbound lead within the minute, qualify it like your best ISA, and put it on the right agent's calendar. Your CRM and your agents keep working exactly the way they do today." data-id="element-397" data-mp="1ffciq1y7fpof" />
      <HowItWorks data-id="element-398" data-mp="30qurz4ezbwk7" />
      <DispatchBrain data-id="element-399" data-mp="30tgv8ruu7pwm" />
      <PromiseSection data-id="element-400" data-mp="1sweij2zsfqqq" />
      <StackSection data-id="element-401" data-mp="1sv37qj7xdiq4" />
      <Faq data-id="element-402" data-mp="1svmnbta3rv0z" />
      <CtaBand title="See it answer a lead on your own script." body="Fifteen minutes, a live demo, and the response-time gaps we find in your current setup. Then you decide." data-id="element-403" data-mp="1sy8wfxcn6ilb" />
    </>;
}